const TONES = {
  success: "bg-[#34d399]/15 text-[#34d399] border-[#34d399]/30",
  info: "bg-[#a855f7]/15 text-[#c084fc] border-[#a855f7]/30",
  warn: "bg-amber-400/15 text-amber-300 border-amber-400/30",
  muted: "bg-white/5 text-muted-foreground border-white/10",
};

export default function StatusPill({ tone = "muted", children, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
